import React from 'react';
import { Link } from 'react-router-dom';
import Page from '../page';
import { choosePath } from '../helpers';
import Footer from '../footer';

const Lookup = ({
  title,
  lead,
  landingStepContent,
  selectableElectorates,
  selectableParties,
  userInput: { selectedElectorateId, selectedPartyId },
  setUserInput
}) => {
  const infoPanel = (
    <div dangerouslySetInnerHTML={{ __html: landingStepContent }} />
  );

  const footer = (
    <Footer
      step={1}
      right={
        <Link
          className="btn btn-redpink btn-block"
          to={choosePath({
            electorate: selectedElectorateId,
            party: selectedPartyId
          })}
        >
          Next →
        </Link>
      }
    />
  );

  const header = (
    <h2 className="h4 mb-0 text-uppercase text-center">Get started</h2>
  );

  const renderParty = (party) => {
    const checked = party.id === selectedPartyId;
    return (
      <div key={party.id}>
        <div className="row">
          <div className="col-7 col-sm-8 ">
            <p className="h5">{party.name}</p>
          </div>
          <div className="col-5 col-sm-4">
            <label
              className={`btn btn-sm btn-block lookup-form__select-party-button${
                checked ? ' btn-redpink' : ' btn-outline-redpink'
              }`}
              htmlFor={party.id}
            >
              <input
                type="radio"
                id={party.id}
                checked={checked}
                value={party.id}
                onChange={() => {
                  setUserInput({ selectedPartyId: party.id });
                }}
              />
              {checked ? 'Selected' : 'Select'}
              {checked && (
                <i
                  className="fa fa-check ml-1 d-none d-sm-inline"
                  aria-hidden="true"
                />
              )}
            </label>
          </div>
        </div>
        <hr />
      </div>
    );
  };

  return (
    <Page
      title={title}
      lead={lead}
      infoPanel={infoPanel}
      header={header}
      footer={footer}
    >
      <p>
        MPs are mostly likely to listen to people from their electorate or
        people who vote for their party.
      </p>
      <div className="form-group">
        <label className="h5" htmlFor="electorate">
          Are you in one of these electorates?
        </label>
        <select
          id="electorate"
          name="electorate"
          className="form-control"
          value={selectedElectorateId}
          aria-describedby="electorateHelpBlock"
          onChange={(event) =>
            setUserInput({ selectedElectorateId: event.target.value })
          }
        >
          <option key="unknown" value="">
            No or I'm not sure
          </option>
          {selectableElectorates.map((se) => (
            <option key={se.id} value={se.id}>
              {se.name}
            </option>
          ))}
        </select>
        <small id="electorateHelpBlock" className="form-text text-muted">
          Only electorates that relate to this campaign will be shown. Feel free
          to skip.
        </small>
      </div>

      <div className="form-group">
        <label className="h5 mb-4" htmlFor="party">
          Did you vote for one of these parties in 2020?
        </label>
        <div id="party" role="radiogroup" aria-describedby="partyHelpBlock">
          {selectableParties.map((party) => renderParty(party))}
          {renderParty({ id: 'no-vote', name: `I didn't vote` })}
        </div>
        <small id="partyHelpBlock" className="form-text text-muted">
          Feel free to skip.
        </small>
      </div>
    </Page>
  );
};

export default Lookup;
